import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Helper component to automatically fit bounds
const FitBounds = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    if (bounds.length > 0) {
      map.fitBounds(bounds, { padding: [50, 50] });
      map.invalidateSize();
    }
  }, [bounds, map]);
  return null;
};

const TreasureMap = ({ markers, circles }) => {
  const validMarkers = (markers || []).filter(marker =>
    typeof marker.latitude === 'number' && !isNaN(marker.latitude) &&
    typeof marker.longitude === 'number' && !isNaN(marker.longitude)
  );

  const validCircles = (circles || []).filter(circle =>
    typeof circle.latitude === 'number' && !isNaN(circle.latitude) &&
    typeof circle.longitude === 'number' && !isNaN(circle.longitude) &&
    typeof circle.radius === 'number' && circle.radius > 0
  );

  if (validMarkers.length === 0 && validCircles.length === 0) {
    return <p>표시할 위치 데이터가 없습니다.</p>;
  }

  const allPoints = [
    ...validMarkers.map(m => [m.latitude, m.longitude]),
    ...validCircles.map(c => [c.latitude, c.longitude]),
  ];

  const center = allPoints[0];

  return (
    <MapContainer center={center} zoom={13} style={{ height: '100%', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {validMarkers.map((marker, index) => (
        <Marker key={marker.boxKey || index} position={[marker.latitude, marker.longitude]}>
          <Popup>
            {marker.hitscore !== undefined ? (
              <>
                <strong>{marker.goalname}</strong><br />
                점수: {marker.hitscore}<br />
                위도: {marker.latitude}<br />
                경도: {marker.longitude}
              </>
            ) : (
              <>
                <strong>{marker.boxName}</strong><br />
                {marker.itemName}<br />
                남은 수량: {marker.remainingCount}
              </>
            )}
          </Popup>
        </Marker>
      ))}
      {validCircles.map((circle, index) => (
        <Circle
          key={circle.key || index}
          center={[circle.latitude, circle.longitude]}
          radius={circle.radius}
          pathOptions={{ color: '#0d6efd', fillColor: '#0d6efd', fillOpacity: 0.15 }}
        >
          <Popup>
            <strong>{circle.label || `포스터 ${index + 1}`}</strong><br />
            위도: {circle.latitude}<br />
            경도: {circle.longitude}<br />
            반경: {circle.radius}m
          </Popup>
        </Circle>
      ))}
      <FitBounds bounds={allPoints} />
    </MapContainer>
  );
};

export default TreasureMap;